import { Component, input } from "@angular/core";

@Component({
  selector: "app-signal-glow-wrapper",
  templateUrl: "./signal-glow-wrapper.component.html",
})
export class SignalGlowWrapperComponent {
  adjustmentClasses = input<string>("");
  isSignal = input<boolean>(false);
}
